import LinksMcom from './mcom/Links';
import LinksBcom from './bcom/Links';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? LinksBcom : LinksMcom;
